import React from 'react';
import PropTypes from 'prop-types';
import Chart from "react-apexcharts";
import {useTheme, makeStyles, Paper, Typography} from '@material-ui/core';
import "./chart.css";
import {themeTypeToBool} from '../../../utils/helpers';
import t from "../../../languages/pl";

const useStyles = makeStyles(theme => ({
    container: {
        minWidth: 350,
        height: 290,
        margin: theme.spacing(1),
        background: theme.palette.background.paper,
        position: "relative"
    },
    chart: {
        margin: "0 auto"
    },
    title: {
        textAlign: "center",
        margin: "auto",
        paddingTop: 15
    }
}));

function CircularGauge(props) {
    const value = props.value? Math.round(props.value) : 0;
    const theme = useTheme();
    const classes = useStyles(theme);
    const params = {
        series: [value],
        options: {
            chart: {
                type: 'radialBar',
                offsetY: -20,
                animations: {
                    enabled: true,
                    easing: 'easeinout',
                    speed: 10000,
                    dynamicAnimation: {
                        enabled: true,
                        speed: 10000
                    }
                }
            },
            plotOptions: {
                radialBar: {
                    startAngle: -90,
                    endAngle: 90,
                    hollow: {

                    },
                    track: {
                        background: themeTypeToBool(theme.palette.type) ? "#FFDBB7" : "#FFAA56",
                        strokeWidth: '97%',
                        margin: 5, // margin is in pixels
                        dropShadow: {
                            enabled: true,
                            top: 2,
                            left: 0,
                            color: '#999',
                            opacity: 1,
                            blur: 2
                        }
                    },
                    dataLabels: {
                        name: {
                            show: false
                        },
                        value: {
                            offsetY: -2,
                            fontSize: theme.typography.h4.fontSize,
                            color: themeTypeToBool(theme.palette.type) ? "#000" : "#FFF",
                            fontWeight: 'bold',
                            fontFamily: theme.typography.h4.fontFamily,
                            formatter: function(val) {
                                return val + "%";
                            }
                        }
                    }
                }
            },
            fill: {
                colors:['#F25B48'],
                type: 'gradient',
                gradient: {
                    shade: 'light',
                    shadeIntensity: 0.4,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 50, 53, 91]
                },
            },
            states: {
                hover: {
                    filter: {
                        type: "none"
                    }
                },
                active: {
                    filter: {
                        type: "none"
                    }
                }
            },
            labels: ['Average Results'],
        }
    };

        return (
            <Paper square className={classes.container}>
                <Typography variant="subtitle2" className={classes.title}>
                    {t.privateModeDrive}
                    <br/>
                    ({t.dailyMileagePercent})
                </Typography>

                <Chart options={params.options}
                    series={params.series}
                    type="radialBar"
                    height="150%"
                    className={classes.chart} />
            </Paper>
        );
}

export default CircularGauge;

CircularGauge.propTypes = {
    value: PropTypes.number
};
